import { Outlet } from "react-router";

// Root layout — sits inside <ClerkProvider> / <ThemeProvider> set up in
// main.tsx. Acts as the seam where future loaders / global error
// boundaries land in phase 5.
export function SpaRoot() {
  return <Outlet />;
}
